// workflow_ids [DEV, PROD]
const baseWorkflowIdDocument = [
  "b0b02032-0cd9-4ba4-978f-e59eda00483d",
  "b2a2989b-346d-423e-b400-698532a1d1a1",
];

export function getBaseWorkflow(): string {
  return baseWorkflowIdDocument[process.env.NODE_ENV === "production" ? 1 : 0];
}

const specialWorkflowsStage: Record<string, string> = {
  formalLanguage: "78592ebd-4e5f-4411-b0a8-f07258a0bd92",
  informalLanguage: "71d49b56-655b-442b-aabb-ce41ee452979",
  anonymize: "34d4c8f4-2605-4845-ae57-bddc07a766f5",
  formulateProfessionally: "7b0c365f-b24a-48ea-89ec-4d40f1a8aa81",
  simpleLanguage: "cea07292-d7d7-49ac-8b8e-8ebf05adb957",
  translateToEnglish: "a56c8c42-3fcd-44ef-ba4b-627d56d72205",
  translateToGerman: "a2f8a635-6c49-411c-81eb-fa57c1c5cf68",
  prepareTemplate: "98e6276c-616e-45b6-9b70-67ce7b4b7056",
  compressAndShorten: "10912d69-043c-4299-88df-18842c1423d5",
  // adjustNumberGender: "",
  // masculineForm: "",
  // feminineForm: "",
  // genderNeutralWording: "",
  // genderWithUnderscore: "",
  // genderWithDualMention: "",
  // genderWithColon:"",
  // genderWithBinnenI: "",
};

const specialWorkflowsProd: Record<string, string> = {
  formalLanguage: "17cf0ada-9615-4601-9e4d-fffc2fd3c22e",
  informalLanguage: "d75263c7-d64c-4420-98fa-cedda2801d78",
  anonymize: "fd9a07e7-9a57-4b14-8f21-1e0a231102cb",
  formulateProfessionally: "d058b43d-5cf4-4107-b3c6-a690b9f7d818",
  simpleLanguage: "5cc70b4d-266b-4849-9c3a-1da3624d7713",
  translateToEnglish: "dd23af09-7948-447d-b799-02d517b4cb94",
  translateToGerman: "18743e3c-9de7-4ed1-8bae-dd59ec954d38",
  prepareTemplate: "04d57194-5abe-4a35-a753-116769ff2772",
  compressAndShorten: "e628dacf-90ba-40b2-908f-33491a53573e",
  adjustNumberGender: "e5f0dacf-64c1-461a-a0f8-f5f6432e6657",
  masculineForm: "e445512b-6e02-45cd-a37d-b7d798828856",
  feminineForm: "15a98025-7eae-43fc-88b3-35275881a5aa",
  genderNeutralWording: "6c347fb1-5179-445a-8d1f-b155f7924636",
  genderWithUnderscore: "f359d0ac-10bc-44cf-90b5-41b9e8215419",
  genderWithDualMention: "7ab91d34-c2ab-4f39-a225-d3a5864a024f",
  genderWithColon: "e89d4e81-dd5b-4082-aed2-a1f41fa5788a",
  genderWithBinnenI: "886fcf85-165a-46fe-9e6a-905e30cee0ad",
};

export function getSpecialWorkflows(): Record<string, string> {
  return process.env.NODE_ENV === "production" ? specialWorkflowsProd : specialWorkflowsStage;
}

export function getSpecialWorkflowId(specialWorkflowName: string): string {
  return getSpecialWorkflows()[specialWorkflowName] ?? "";
}
